<div class="mb-5 mb-sm-4 text-center text-sm-start">
  <a class="account-nav-link"
     [routerLink]="['details']"
     [routerLinkActive]="'active'">{{'CUSTOMER-ACCOUNT.NAVIGATION.ACCOUNT' | translate}}</a>
  <a class="account-nav-link ms-sm-2"
     [routerLink]="['visits']"
     [routerLinkActive]="'active'">{{'CUSTOMER-ACCOUNT.NAVIGATION.VISITS' | translate}}</a>
</div>
